import React, { useEffect } from 'react'
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, Hidden } from "@material-ui/core"
import { showGuides } from "@src/utils/debug"
import FluidImage from "../components/FluidImage"
import Module from "../components/Module"
import Text from "../components/Text"
import Parallax from "../components/Parallax"
import { Parallax as ParallaxItem } from "react-scroll-parallax"
import { useMediaQuery } from "@material-ui/core"
import KlarnaPlacement from "../components/KlarnaPlacement"
import clsx from "clsx"
import "../style/aboutModule.css"
import CtaButton from '../components/CtaButton';
import SnakeCommerceCart from '../../static/cart';

const parallaxHeight = 450

const left = "LEFT"

const useStyles = makeStyles(theme => ({
  about: {
    marginTop: theme.spacing(1 / 2),
    marginBottom: theme.spacing(1 / 2),
    [theme.breakpoints.down('md')]: {
      paddingRight: 32,
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      float: "initial !important",
    },
  },
  contentContainerReverse: {
    display: "flex",
    flexDirection: "row-reverse",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      float: "initial !important",
    },
  },
  editorialContent: {
    float: "left",
    width: "40%",
    marginRight: "5%",
    marginTop: "auto",
    marginBottom: "auto",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      color: "white",
      padding: theme.spacing(4, 4, 0, 4),
      marginRight: "initial",
      
    },
  },
  editorialContentRight: {
    float: "right",
    width: "40%",
    marginLeft: "0px !important",
    marginTop: "auto",
    marginBottom: "auto",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      color: "white",
      padding: theme.spacing(4, 4, 0, 4),
      marginRight: "initial",
    },
  },
  editorialContentCentered: {
    width: "100%",
    marginTop: "auto",
    marginBottom: "auto",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: theme.spacing(4, 4, 0, 4),
      marginRight: "initial",
    },
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
    "&:before": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: "auto",
        marginRight: "auto",
      },
    },
  },
  titleCentered: {
    textAlign: "center",
    "&:before": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  text: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
      padding: theme.spacing(4, 0, 0, 0),
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: 18,
      lineHeight: 1.22,
    },
  },
  imageWrapper: {
    position: "relative",
    //overflow: 'hidden',
    float: "right",
    width: "55%",
  },
  parallaxWrapper: {
    position: "absolute",
    border: showGuides("4px dashed gray"),
    right: -theme.spacing(8),
    top: "50%",
    transform: "translate3d(0, -50%, 0)",
    maxHeight: 450,
    width: "100%",
    zIndex: -1,
  },
  parallaxWrapperLeft: {
    position: "absolute",
    border: showGuides("4px dashed gray"),
    left: -theme.spacing(8),
    top: "50%",
    transform: "translate3d(0, -50%, 0)",
    maxHeight: 450,
    width: "100%",
    zIndex: -1,
  },
  parallax: {
    zIndex: -1,
  },
  background: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: '80%', // FIX ** to be align with visual...
    zIndex: -1,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    '&.noCode': {
      height: '85%'
    }
  },
  foreground: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
      width: "100%",
    },
  },
  copyright: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  copyrightCentered: {
    paddingTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  copyrightImage: {
    width: "auto",
    height: 65,
    textAlign: "left", // FIX ** align to left...
    [theme.breakpoints.down("sm")]: {
      textAlign: "center", // FIX ** align to left...
      height: 55,
    },
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: theme.spacing(0, 2),
      marginTop: theme.spacing(10),
      '&.noCode': {
        marginTop: theme.spacing(6),
      }
    },
  },
  ctaButton: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& h4': {
      fontWeight: '500 !important',
      fontSize: '1.1rem !important',
    }
  },
  buttonAddToCart: {
    width: '50%',
    height: 48,
    background: '#fff',
    border: '2px solid #f29100',
    fontSize: '1.1rem !important',
    fontStyle: 'normal',
    fontFamily: '"Spezia", "Roboto", "Open Sans", "Helvetica", "Arial", "sans-serif"',
    fontWeight: '500 !important',
    lineHeight: '1.6rem',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: '#060b1d',
    minWidth: 64,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.18)',
    boxSizing: 'border-box',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, ' +
      'box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, ' +
      'border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, ' +
      'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: 2,
    '&:hover': {
      color: '#be7425',
      borderColor: '#be7425',
      cursor: 'pointer',
      backgroundColor: '#fff',
    },
    '&:disabled': {
      color: '#a1a1a1',
      border: '1px solid #a1a1a1',
      cursor: 'not-allowed',
      pointerEvents: 'none',
      backgroundColor: '#d6d6d6',
      backgroundImage: 'none',
    },
    '&.wFull': {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      color: '#F29100',
    },
  },
}))

const Copyright = ({ copyright, copyrightImage, centered }) => {
  const classes = useStyles()
  return (
    <div className={centered ? classes.copyrightCentered : classes.copyright}>
      <FluidImage
        className={classes.copyrightImage}
        {...copyrightImage}
      ></FluidImage>
      <Text variant="bodyXS" component="p">
        {copyright}
      </Text>
    </div>
  )
}

const AboutModule = props => {

  const {
    title,
    text,
    foregroundImage,
    backgroundImage,
    mobileBackgroundImage,
    copyright,
    copyrightImage,
    images_gallery_position,
    active_klarna_web_messaging,
    cta_subscription,
    repo,
    ecommerce_item_btn_text,
    first_figure_ecommerce_code
  } = props

  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))


  const ButtonLinks = () => {
    useEffect(() => {
      SnakeCommerceCart.init()
    }, []);

    return (
      <div className={clsx(classes.buttonWrapper, !first_figure_ecommerce_code && 'noCode')}>
        {first_figure_ecommerce_code && <button
          className={clsx(
            classes.buttonAddToCart, !cta_subscription?.productCode && 'wFull', 'add-cart-item-trigger', 'button-add-to-cart'
          )}
          data-sku={first_figure_ecommerce_code}
        >
          {ecommerce_item_btn_text}
        </button>
        }
        {cta_subscription?.productCode && (
          <CtaButton
            className={classes.ctaButton}
            productCode={cta_subscription?.productCode}
            {...cta_subscription}
            size="large"
            trackingObj={repo}
            nameModule="AboutModule"
            trackingAction="click_link"
            trackingLabel={'AboutModule - ' + cta_subscription.productCode}
          />
        )}
      </div>
    );
  };


  return (
    <Module
      className={clsx(classes.about, "About")}
      classes={{
        container:
          images_gallery_position === left
            ? classes.contentContainerReverse
            : classes.contentContainer,
      }}
      variant="left"
    >
      <Box
        className={
          foregroundImage || backgroundImage
            ? images_gallery_position === left
              ? classes.editorialContentRight
              : classes.editorialContent
            : classes.editorialContentCentered
        }
      >
        <Text
          className={
            foregroundImage || backgroundImage
              ? classes.title
              : classes.titleCentered
          }
          variant="titleXXXL"
          component="h2"
          overline
          weight="bold"
          color={
            foregroundImage || backgroundImage
              ? classes.title
              : classes.titleCentered
          }
        >
          {title}
        </Text>
        <Text className={classes.text} component="p" variant="titleXL">
          {text}
        </Text>
        {active_klarna_web_messaging && (
          <KlarnaPlacement repo={repo} moduleName={"About"} />
        )}
        {copyrightImage && <Copyright
          centered={!backgroundImage || !foregroundImage}
          copyright={copyright}
          copyrightImage={copyrightImage}
        />
        }
        <Hidden mdUp>
          <FluidImage
            className={classes.foreground}
            {...foregroundImage}
          ></FluidImage>
        </Hidden>
        <Hidden smDown>
          <ButtonLinks/>
        </Hidden>
      </Box>
      {foregroundImage || backgroundImage ? (
        <Hidden smDown>
          <Box className={classes.imageWrapper}>
            <Box
              className={
                images_gallery_position === left
                  ? classes.parallaxWrapperLeft
                  : classes.parallaxWrapper
              }
            >
              <Parallax
                className={classes.parallax}
                bgImage={backgroundImage}
                bgMobileImage={backgroundImage}
                /*blur={0}*/
                amount={0.35}
              >
                <div style={{ height: parallaxHeight, width: "100%" }}></div>
              </Parallax>
            </Box>
            <ParallaxItem
              disabled={isMobile}
              className={classes.parallaxItem}
              y={["3", "-3"]}
            >
              <FluidImage
                className={classes.foreground}
                {...foregroundImage}
              ></FluidImage>
            </ParallaxItem>
          </Box>
        </Hidden>
      ) : null}

      {mobileBackgroundImage && mobileBackgroundImage.src ? (
        <Hidden mdUp>
          <div
            className={clsx(classes.background, !first_figure_ecommerce_code && 'noCode')}
            style={{
              backgroundImage: `url(${
                mobileBackgroundImage ? mobileBackgroundImage.src : ""
              })`,
            }}
          ></div>
        </Hidden>
      ) : null}
      <Hidden mdUp>
        <ButtonLinks/>
      </Hidden>
    </Module>
  )
}

export default AboutModule
